/**
 * defa.views.PhoneNumberCreateForm
 * A form for creating new PhoneNumbers.
 * @version 1.2.1
 */
import { defa } from 'defa-object';
import Form     from 'scripts/poppet/form';
import template from 'templates/phoneNumberCreateForm.jst.html';

const selectors             = {
	html            : 'html',
	inputDescription: '[data-input=phone-number-description]',
	inputNumber     : '[data-input=phone-number-number]',
};
const PhoneNumberCreateForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: 'card no-hidden',
	
	ui: {
		description: selectors.inputDescription,
		number     : selectors.inputNumber,
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the view renders.
	 * @void
	 */
	onRender: function () {
		
		let country   = '',
			customer  = !1,
			countries = [ 'no', 'se', 'dk', 'fi', ],
			customers = this.options.currentUser.getCustomers();
		
		// if this user got customers, use the latest customer to define country.
		if ( 1 <= customers.length ) {
			
			customer = this.options.currentUser.getCustomers().max( function ( model ) {
				return model.get( 'id' );
			} );
			country  = customer.get( 'countryCode' );
			
			// use the current html-language to define country.
		} else {
			country = defa.objects.languageSettings.country;
		}
		
		// add country to the top of the array and remove duplicates
		countries.unshift( country.toLowerCase() );
		countries = _.uniq( countries );
		
		this.ui.number.intlTelInput( {
			preferredCountries: countries,
			utilsScript       : '/assets/vendor/intl-tel-input-utils.min.js',
			autoPlaceholder   : 'off',
			separateDialCode  : true,
		} );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attempts to save the information to the Model.
	 * @void
	 */
	submit: function () {
		let prefix = '+' + this.ui.number.intlTelInput( 'getSelectedCountryData' ).dialCode,
			number = this.ui.number.intlTelInput( 'getNumber' ).replace( prefix, '' );
		
		let form = {
			user       : this.options.currentUser.get( 'id' ),
			prefix     : prefix,
			number     : number,
			description: this.ui.description.val().trim(),
		};
		
		this.model.save( form );
	},
	
} );


export default PhoneNumberCreateForm;